import { useContext, useEffect, useState } from "react";
import { AlertContext } from "../../../context/AlertContext";
import { AcknowledgementModal } from "../AcknowledgementModal/acknowledgement-modal";

import infoIcon from "../../../assets/images/info.png";
import warningIcon from "../../../assets/images/warning.png";
import successIcon from "../../../assets/images/greenCheck.png";
import errorIcon from "../../../assets/images/error.png";

import './global-alert.css'

export default function GlobalAlert() {
  //context
  const { alertState } = useContext(AlertContext);

  useEffect(() => {
    setShowGLobalAlert(alertState.isActive);
  }, [alertState.index]);

  //state
  const [showGlobalAlert, setShowGLobalAlert] = useState(alertState.isActive ?? false);

  const getIcon = () => {
    switch (alertState.type) {
      case "info":
        return infoIcon;
      case "warning":
        return warningIcon;
      case "success":
        return successIcon;
      case "error":
        return errorIcon;
    }
  };

  function onAcknowledge() {
    setShowGLobalAlert(false);
    if (alertState.onAcknowledge) {
      alertState.onAcknowledge();
    }
  }

  return (
    <AcknowledgementModal
      id="global-alert-modal"
      animate={true}
      isActive={showGlobalAlert}
      header={alertState.header}
      message={alertState.message}
      showDivider={true}
      icon={getIcon()}
      buttonText={alertState.buttonText ?? "Ok"}
      onAcknowledge={onAcknowledge}
    />
  );
}
